import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import { Dropdown } from "react-bootstrap";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { dateFormat } from "../../../utils/date";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del, get, post } from "../../../services/api";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import Status from "../Common/Status";
import { getAllJobs } from "../../../store/actions/Jobs/jobActions";
import { days, weekdays } from "../../constant/weekday";
import RequirementCandidates from "./RequirementCandidates";
import AssignCandidate from "./AssignCandidate";
import UnAssignedCandidate from "./UnAssignedCandidate";
import ExtendRequirement from "./ExtendRequirement";
import CopyRequirement from "./CopyRequirement";
import CandidateSearchBar from "./CandidateSearchBar";
import dayjs from "dayjs";
import "./Requirement.css";

const RequirementList = ({ title, allJobs, token, attendanceStatusList, jobTypeList }) => {
  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openCandidatesModal && location.state?.selectedRequirement) {
      setSelectedRequirement(location.state.selectedRequirement);
      setShowEditCandidateModal(true);
      // Clear the location state to prevent reopening on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  // Initialize weekRange from URL if present
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const weekStart = searchParams.get("weekStart");
    const weekEnd = searchParams.get("weekEnd");
    if (weekStart && weekEnd) {
      const startDate = new Date(weekStart);
      const endDate = new Date(weekEnd);
      setWeekRange({ startDate, endDate });

      // Derive week number from start date
      const startOfYear = new Date(startDate.getFullYear(), 0, 1);
      const daysSinceStartOfYear = Math.floor((startDate - startOfYear) / (24 * 60 * 60 * 1000));
      const derivedWeekNumber = Math.ceil((daysSinceStartOfYear + 1) / 7);
      setWeekNumber(derivedWeekNumber);
    }
  }, [location.search]);
  const dispatch = useDispatch();
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [weekRange, setWeekRange] = useState(getCurrentWeek());
  const [weekNumber, setWeekNumber] = useState();
  const [selectedCompany, setSelectedCompany] = useState({});
  const [showEditCandidateModal, setShowEditCandidateModal] = useState(false);
  const [showAssignCandidateModal, setShowAssignCandidateModal] = useState(false);
  const [showUnAssignCandidateModal, setShowUnAssignCandidateModal] = useState(false);
  const [showExtendModal, setShowExtendModal] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [selectedRequirement, setSelectedRequirement] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [timesheetStatus, setTimesheetStatus] = useState({});
  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);

  const recordsPage = 10;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const npage = Math.ceil(filteredJobs.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  // Current page records derived from the full checked array
  const records = checked.slice(firstIndex, lastIndex);

  function getCurrentWeek() {
    const currentDate = new Date();
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 1);

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    return { startDate: firstDayOfWeek, endDate: lastDayOfWeek };
  }

  const handleWeekChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const firstDayOfWeek = new Date(selectedDate);
    firstDayOfWeek.setDate(selectedDate.getDate() - selectedDate.getDay() + 1);

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    setWeekRange({ startDate: firstDayOfWeek, endDate: lastDayOfWeek });

    const startOfYear = new Date(selectedDate.getFullYear(), 0, 1);
    const daysSinceStartOfYear = Math.floor(
      (selectedDate - startOfYear) / (24 * 60 * 60 * 1000)
    );

    const weekNumber = Math.ceil((daysSinceStartOfYear + 1) / 7);
    setWeekNumber(weekNumber);
    setCurrentPage(1);
  };

  const [weeklyAttendance, setWeeklyAttendance] = useState([]);

  const fetchWeeklyAttendance = async (jobId) => {
    try {
      const payload = {
        weekStartDate: dayjs(weekRange.startDate).format("YYYY-MM-DD"),
        weekEndDate: dayjs(weekRange.endDate).format("YYYY-MM-DD"),
        requirementId: jobId
      };
      const response = await post("/api/timesheet/get/weekly", payload, token);
      return response?.data?.data || [];
    } catch (error) {
      console.error('Error fetching weekly attendance:', error);
      return [];
    }
  };

  const checkAllTimesheetStatuses = async () => {
    const statuses = {};

    for (const job of filteredJobs) {
      try {
        if (!job.candidates || job.candidates === 0) {
          statuses[job._id] = null;
          continue;
        }

        const candidatesResponse = await get(`/api/job/candidate/job/${job._id}?weekStartDate=${dayjs(weekRange.startDate).format('YYYY-MM-DD')}&weekEndDate=${dayjs(weekRange.endDate).format('YYYY-MM-DD')}`, token);

        if (!candidatesResponse?.length) {
          statuses[job._id] = false;
          continue;
        }

        const weeklyData = await fetchWeeklyAttendance(job._id);

        const candidateIds = candidatesResponse.map(c => c.candidateId);

        const allSubmitted = candidateIds.length > 0 && candidateIds.every(candidateId =>
          weeklyData.some(entry =>
            entry.candidateId === candidateId &&
            entry.isSubmitted === true
          )
        );

        statuses[job._id] = allSubmitted;

      } catch (error) {
        console.error(`Error checking timesheet status for job ${job._id}:`, error);
        statuses[job._id] = false;
      }
    }

    setTimesheetStatus(statuses);
  };

  useEffect(() => {
    // if (filteredJobs.length > 0) {
    //   checkAllTimesheetStatuses();
    // }
  }, [filteredJobs, weekRange]);

  useEffect(() => {
    // if (weeklyAttendance.length > 0) {
    //   checkAllTimesheetStatuses();
    // }
  }, [weeklyAttendance]);

  const handleAllPositionsClick = async (item) => {
    setSelectedRequirement(item);
    setShowEditCandidateModal(true);
  };

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const handleChecked = (id) => {
    setChecked((prevChecked) => {
      const updatedChecked = prevChecked.map((candidate) =>
        candidate._id === id
          ? { ...candidate, inputchecked: !candidate.inputchecked }
          : candidate
      );
      
      // Find the item that was just checked/unchecked
      const changedItem = updatedChecked.find(item => item._id === id);
      
      // Update selectedItems based on the new checked state
      if (changedItem && changedItem.inputchecked) {
        // Item was checked, add it to selectedItems
        setSelectedItems(prev => [...prev, changedItem]);
      } else {
        // Item was unchecked, remove it from selectedItems
        setSelectedItems(prev => prev.filter(item => item._id !== id));
      }
      
      return updatedChecked;
    });
  };

  const handleCheckedAll = (value) => {
    // Only toggle items on the current page
    const currentPageIds = new Set(checked.slice(firstIndex, lastIndex).map(d => d._id));
    let temp = checked.map((data) => {
      if (currentPageIds.has(data._id)) {
        return { ...data, inputchecked: value };
      }
      return data;
    });
    setChecked(temp);
    setUnChecked(!unchecked);
    
    // Update selectedItems: add/remove only current page items, keep other pages' selections
    if (value) {
      const currentPageItems = temp.filter(d => currentPageIds.has(d._id));
      setSelectedItems(prev => {
        const otherPages = prev.filter(item => !currentPageIds.has(item._id));
        return [...otherPages, ...currentPageItems];
      });
    } else {
      setSelectedItems(prev => prev.filter(item => !currentPageIds.has(item._id)));
    }
  };

  const assignCandidate = () => {
    const selectedReq = checked?.filter((itm) => itm.inputchecked === true);
    if (selectedReq?.length === 0) {
      toast.warn(
        "Please select the requirement to which you want to assign candidates."
      );
    } else {
      toast.info("Feature build is in progress.");
    }
  };

  const handleGenerateConsolidatedInvoice = async (items = null) => {
    // Use passed items or fall back to selectedItems state
    const selectedForInvoice = items || selectedItems;
    console.log('Generate invoice called with items:', selectedForInvoice);
    
    if (!selectedForInvoice || selectedForInvoice.length === 0) {
      toast.warn("Please select at least one requirement to generate a consolidated invoice.");
      return;
    }

    // Check if all selected items have the same company
    const firstCompany = selectedForInvoice[0].company;
    const allSameCompany = selectedForInvoice.every(item => item.company === firstCompany);

    if (!allSameCompany) {
      toast.error("You can't generate the consolidated invoice for different companies. Please select requirements from the same company.");
      return;
    }
    
    try {
      toast.info("Checking candidate attendance...");
      
      // Get the job IDs from the selected items
      const selectedJobIds = selectedForInvoice.map(item => item._id);
      
      // Fetch candidates for each selected job
      const candidatePromises = selectedJobIds.map(jobId => 
        get(`/api/job/candidate/job/${jobId}?weekStartDate=${dayjs(weekRange.startDate).format('YYYY-MM-DD')}&weekEndDate=${dayjs(weekRange.endDate).format('YYYY-MM-DD')}`, token)
      );
      
      const candidateResponses = await Promise.all(candidatePromises);
      
      // Check attendance submission status
      const attendancePromises = selectedJobIds.map(jobId => fetchWeeklyAttendance(jobId));
      const attendanceResponses = await Promise.all(attendancePromises);
      
      let allSubmitted = true;
      let alreadyInvoiced = false;
      let existingInvoiceNo = "";
      
      candidateResponses.forEach((candidates, index) => {
        if (candidates && candidates.length > 0) {
          const weeklyData = attendanceResponses[index] || [];
          candidates.forEach(candidate => {
            // Check submission
            const hasSubmitted = weeklyData.some(entry => 
              entry.candidateId === candidate.candidateId && entry.isSubmitted === true
            );
            if (!hasSubmitted) {
              allSubmitted = false;
            }
            
            // Check if already invoiced
            if (candidate.invoiceNo) {
              alreadyInvoiced = true;
              existingInvoiceNo = candidate.invoiceNo;
            }
          });
        }
      });
      
      if (!allSubmitted) {
        toast.error("Cannot generate consolidated invoice: One or more candidates have unsubmitted attendance for the selected week.");
        return;
      }

      if (alreadyInvoiced) {
        toast.error(`Cannot generate consolidated invoice: One or more candidates already have an invoice (${existingInvoiceNo}) for this week.`);
        return;
      }

      toast.info("Generating consolidated invoice...");

      // Prepare data for API call
      const selectedJobList = [];
      let jobInvoiceTo = null;
      
      // Get job details to find invoice contact information and rates
      const jobDetailsPromises = selectedJobIds.map(jobId => 
        get(`/api/job/${jobId}`, token)
      );
      
      const jobDetailsResponses = await Promise.all(jobDetailsPromises);
      
      // Find the first job with invoice contact information
      for (const jobDetail of jobDetailsResponses) {
        if (jobDetail && jobDetail.jobInvoiceTo) {
          jobInvoiceTo = jobDetail.jobInvoiceTo;
          break;
        }
      }
      
      candidateResponses.forEach((candidates, index) => {
        if (candidates && candidates.length > 0) {
          const jobDetail = jobDetailsResponses[index];
          candidates.forEach(candidate => {
            selectedJobList.push({
              jobCandidateId: candidate._id,
              candidateId: candidate.candidateId,
              jobId: selectedJobIds[index],
              invoiceNo: candidate.invoiceNo || "",
              jobInvoiceTo: jobInvoiceTo || candidate.jobInvoiceTo || "",
              company: selectedForInvoice[index].company,
              jobTitle: selectedForInvoice[index].jobTitle,
              payRate: jobDetail?.payRate || 0,
              chargeRate: jobDetail?.chargeRate || 0
            });
          });
        }
      });
      
      if (selectedJobList.length === 0) {
        toast.warn("No candidates found for the selected requirements.");
        return;
      }

      // Call the consolidated invoice API
      const payload = {
        selectedjobList: selectedJobList,
        weekStartDate: dayjs(weekRange.startDate).format("YYYY-MM-DD"),
        weekEndDate: dayjs(weekRange.endDate).format("YYYY-MM-DD"),
        requirementId: selectedJobIds[0]
      };

      const { data: response } = await post("/api/timesheet/consolidated-invoice", payload, token);
      
      if (response && response.filedata && response.filename) {
        // Convert base64 to blob for download
        const byteCharacters = atob(response.filedata);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.filename);
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
        
        toast.success("Consolidated invoice generated and downloaded successfully.");
      } else {
        toast.error("Failed to download invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error generating consolidated invoice:", error);
      toast.error(`Failed to generate consolidated invoice: ${error.message || 'Unknown error'}`); 
    }
  };

  useEffect(() => {
    if (!weekRange.startDate || !weekRange.endDate) return;

    const filtered = allJobs.filter((job) => {
      const startDate = new Date(job.jobStartDate);
      const endDate = new Date(job.jobEndDate);

      return (
        (startDate >= weekRange.startDate && startDate <= weekRange.endDate) ||
        (endDate >= weekRange.startDate && endDate <= weekRange.endDate) ||
        (startDate <= weekRange.startDate && endDate >= weekRange.endDate)
      );
    });

    setFilteredJobs(filtered);

    // if (filtered.length > 0) {
      // checkAllTimesheetStatuses();
    // }

    setExportData(
      allJobs.map(
        ({
          jobID,
          company,
          jobTitle,
          regDate,
          jobStartDate,
          jobEndDate,
          service,
          status,
          jobType,
          jobContact,
          location,
          daysOfWork,
          postCode,
          candidates,
          orderNumber,
          accountNumber,
          reason,
          feePercentage,
          quantity,
        }) => ({
          jobID,
          jobStartDate: dayjs(jobStartDate).format("DD/MM/YYYY"),
          jobEndDate: dayjs(jobEndDate).format("DD/MM/YYYY"),
          service,
          status,
          jobType,
          jobContact,
          location,
          daysOfWork,
          postCode,
          candidates: candidates ? Number(candidates) : "",
          orderNumber: orderNumber ? Number(orderNumber) : "",
          accountNumber: accountNumber ? Number(accountNumber) : "",
          reason,
          feePercentage: feePercentage ? Number(feePercentage) : "",
          quantity: quantity ? Number(quantity) : "",
          company,
          jobTitle,
          regDate: dayjs(regDate).format("DD/MM/YYYY"),
        })
      )
    );
  }, [allJobs, weekRange]);

  useEffect(() => {
    // Initialize checked for ALL filteredJobs so selections persist across pages
    const initialChecked = filteredJobs.map((candidate) => ({
      ...candidate,
      inputchecked: false,
    }));
    setChecked(initialChecked);
    setSelectedItems([]);
  }, [filteredJobs]);
  

  useEffect(() => {
    if (location.state && location.state.autoOpenModal && location.state.jobId) {

      const jobToOpen = allJobs.find(job => job._id === location.state.jobId);
      
      if (jobToOpen) {
        setSelectedRequirement(jobToOpen);
        setShowEditCandidateModal(true);
        
        // If this is a direct modal open from search, scroll to the page top
        if (location.state.directModal) {
          window.scrollTo(0, 0);
          
          // Show a brief toast notification to indicate which candidate was found
          if (location.state.candidateName && location.state.planName) {
            toast.info(`Showing ${location.state.candidateName} in ${location.state.planName}`);
          }
        }
        
        // Clear the location state to prevent reopening on refresh
        window.history.replaceState({}, document.title);
      } else if (location.state.directModal) {
        // If we can't find the job but it's a direct modal request, show an error
        toast.error("Couldn't find the selected requirement plan. Please try again.");
        window.history.replaceState({}, document.title);
      }
    }
  }, [location, allJobs]);

  // useEffect(() => {
  //   // if (filteredJobs.length > 0) {
  //     // checkAllTimesheetStatuses();
  //   }
  // }, [filteredJobs]);

  const headers = [
    { label: "Job ID", key: "jobID" },
    { label: "Company", key: "company" },
    { label: "Job Title", key: "jobTitle" },
    { label: "Reg. Date", key: "regDate" },
    { label: "Start Date", key: "jobStartDate" },
    { label: "End Date", key: "jobEndDate" },
    { label: "Service", key: "service" },
    { label: "Status", key: "status" },
    { label: "Job Type", key: "jobType" },
    { label: "Job Contact", key: "jobContact" },
    { label: "Location", key: "location" },
    { label: "Days of work", key: "daysOfWork" },
    { label: "Post Code", key: "postCode" },
    { label: "Candidates", key: "candidates" },
    { label: "Order No.", key: "orderNumber" },
    { label: "Account No.", key: "accountNumber" },
    { label: "Reason", key: "reason" },
    { label: "Fee %", key: "feePercentage" },
    { label: "Quantity", key: "quantity" },
  ];

  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption d-flex justify-content-between align-items-center flex-wrap">
              <h4 className="heading mb-0">{title}</h4>
              <div className="d-flex align-items-center ms-auto">
                <CSVLink
                  headers={headers}
                  data={exportData}
                  filename={"requirement-plan.csv"}
                  className="btn btn-primary light btn-sm me-2"
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </CSVLink>
                <button
                  className="btn btn-success light btn-sm me-2"
                  onClick={() => handleGenerateConsolidatedInvoice()}
                >
                  <i className="fa-solid fa-file-invoice" /> Generate Consolidated Invoice
                </button>
                <CandidateSearchBar token={token} weekRange={weekRange} />
              </div>
            </div>
            <div>
              <div className="filter-section p-3 pt-0">
                <label className="me-3">
                  Select Week:
                  <input
                    type="date"
                    onChange={handleWeekChange}
                    value={weekRange.startDate.toISOString().split("T")[0]}
                    className="form-control"
                  />
                </label>
                {weekNumber ? `Week Number: ${weekNumber}` : null}
              </div>
            </div>
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
                <thead>
                  <tr>
                    <th className="sorting_asc_11">
                      <div className="form-check custom-checkbox ms-0">
                        <input
                          type="checkbox"
                          className="form-check-input checkAllInput"
                          required=""
                          onClick={() => handleCheckedAll(unchecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkAll"
                        ></label>
                      </div>
                    </th>
                    <th>Plan ID</th>
                    <th>Company</th>
                    <th>Job Title</th>
                    <th>Temp</th>
                    <th>Ts</th>
                    <th>
                      <div className="d-flex justify-content-around">
                        {weekdays?.map((itm) => (
                          <>
                            <span className="border">&nbsp;{itm}&nbsp;</span>
                          </>
                        ))}
                      </div>
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {records.length === 0 && (
                    <tr>
                      <td className="text-start" colSpan={9}>
                        No Result Found.
                      </td>
                    </tr>
                  )}
                  {records.map((item, index) => (
                    <tr key={item._id}>
                      <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={item.inputchecked}
                            onChange={() => handleChecked(item._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <p className="mb-0 ms-2">{item.jobID}</p>
                        </div>
                      </td>
                      <td>{item.company}</td>
                      <td>{item.jobTitle}</td>
                      <td>
                        {item.candidates === item.quantity ? (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAllPositionsClick(item);
                            }}
                          >
                            All Positions Filled
                          </button>
                        ) : (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedRequirement(item);
                              setShowEditCandidateModal(true);
                              handleAllPositionsClick(item);
                            }}
                          >
                            {item.quantity - item.candidates} Positions Available
                          </button>
                        )}
                      </td>
                      <td>
                          <span>-</span>
                      </td>
                      <td>
                        <div className="d-flex justify-content-around">
                          {days.map((day, idx) => (
                            <span key={idx}>
                              {item.daysOfWork?.includes(day) ? (
                                <small>R</small>
                              ) : (
                                <small>-</small>
                              )}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td>
                        <Status status={item.status} />
                      </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle as="div" className="btn-link i-false">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="dropdown-menu-right" align="end">
                            <Dropdown.Item onClick={(e) => {
                              nav(`/update-requirement-plans?id=${item._id}&mode=view&weekStart=${dayjs(weekRange.startDate).format("YYYY-MM-DD")}&weekEnd=${dayjs(weekRange.endDate).format("YYYY-MM-DD")}`);
                            }}>
                              View
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              nav(`/update-requirement-plans?id=${item._id}&mode=edit&weekStart=${dayjs(weekRange.startDate).format("YYYY-MM-DD")}&weekEnd=${dayjs(weekRange.endDate).format("YYYY-MM-DD")}`);
                            }}>
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              setSelectedRequirement(item);
                              setTimeout(() => {
                                setShowAssignCandidateModal(true);
                              }, 100);
                            }}>
                              Assign Candidate
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              setSelectedRequirement(item);
                              setTimeout(() => {
                                setShowUnAssignCandidateModal(true);
                              }, 100);
                            }}>
                              UnAssign Candidate
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              setSelectedRequirement(item);
                              setTimeout(() => {
                                setShowExtendModal(true);
                              }, 100);
                            }}>
                              Extend
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              setSelectedRequirement(item);
                              setTimeout(() => {
                                setShowCopyModal(true);
                              }, 100);
                            }}>
                              Copy
                            </Dropdown.Item>
                            <Dropdown.Item onClick={(e) => {
                              e.preventDefault();
                              swal({
                                title: "Are you sure?",
                                text: "Once deleted, you will not be able to recover this requirement!",
                                icons: "warning",
                                buttons: true,
                                confirmButtonText: "Delete",
                                dangerMode: true,
                              }).then(async (willDelete) => {
                                if (willDelete) {
                                  await del("/api/job/" + item?._id, token);
                                  toast.success("Company job has been deleted successfully.");
                                  dispatch(getAllJobs(token));
                                }
                              });
                            }}>
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {filteredJobs.length === 0 ? 0 : firstIndex + 1} to{" "}
                  {lastIndex > filteredJobs.length ? filteredJobs.length : lastIndex}{" "}
                  of {filteredJobs.length} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers justify-content-center" id="example2_paginate">
                  <Link className="paginate_button previous disabled" to="#" onClick={prePage}>
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${currentPage === n ? "current" : ""} `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link className="paginate_button next" to="#" onClick={nextPage}>
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showEditCandidateModal && (
        <RequirementCandidates
          weekRange={weekRange}
          showEditCandidateModal={showEditCandidateModal}
          setShowEditCandidateModal={setShowEditCandidateModal}
          selectedRequirement={selectedRequirement}
          attendanceStatusList={attendanceStatusList}
          jobTypeList={jobTypeList}
        />
      )}
      {showAssignCandidateModal && (
        <AssignCandidate
          showAssignCandidateModal={showAssignCandidateModal}
          setShowAssignCandidateModal={setShowAssignCandidateModal}
          selectedRequirement={selectedRequirement}
        />
      )}
      {showUnAssignCandidateModal && (
        <UnAssignedCandidate
          showAssignCandidateModal={showUnAssignCandidateModal}
          setShowAssignCandidateModal={setShowUnAssignCandidateModal}
          selectedRequirement={selectedRequirement}
        />
      )}
      {showExtendModal && (
        <ExtendRequirement
          showExtendModal={showExtendModal}
          setShowExtendModal={setShowExtendModal}
          selectedRequirement={selectedRequirement}
        />
      )}
      {showCopyModal && (
        <CopyRequirement
          showCopyModal={showCopyModal}
          setShowCopyModal={setShowCopyModal}
          selectedRequirement={selectedRequirement}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    allJobs: state.jobs.allJobList,
    attendanceStatusList: state?.dropDownValues?.dropDownValues?.attendanceStatusList || [],
    jobTypeList: state?.dropDownValues?.dropDownValues?.jobType || [],
  };
};

export default withRouter(connect(mapStateToProps)(RequirementList));
